import { ConditionalLink } from "components/conditionalLink";
import { Button } from "components/DesignSystem/Button/Button";
import { FeatureDetails } from "components/FeatureDetails/FeatureDetails";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { LockDescription } from "pages/Books/RevenueMetrics/RevenueMetricsLocked";
import { useLocation } from "react-router-dom";
import RevenueRecognition from "static/images/RevenueRecognition.png";

export const RevenueRecognitionLocked = () => {
  const { link } = useConstructInternalLink();
  const { pathname } = useLocation();

  const settingsLink = link("/books/books-settings", {
    moreQuery: {
      settings_back_to: link(pathname),
    },
    hash: "AUTOMATION",
  });

  return (
    <section className="t-flex t-justify-center t-items-center t-h-full t-w-full">
      <FeatureDetails
        banner={
          <img
            src={RevenueRecognition}
            alt="Revenue recognition"
            width="360px"
            className="sm:t-h-auto sm:t-w-full"
          />
        }
        description={
          <LockDescription
            descriptionText="Visualize how and when your revenue is recognized, with clear monthly breakdowns and audit-ready details"
            title="Revenue Recognition"
          />
        }
        feature={<></>}
        button={
          <ConditionalLink to={settingsLink}>
            <Button customType="primary" size="regular">
              Enable Revenue Recognition
            </Button>
          </ConditionalLink>
        }
      />
    </section>
  );
};
